import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Alert, Collapse, Row, Col } from 'react-bootstrap';
import { Form } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from 'react-cookie';
import { Heading, ContainerBox } from '../AdminStyle';
import { instanceOf } from 'prop-types';
import { LogeButtonSlim, LodgeButtonLoadingRing } from '../../GeneralStyle'
import Parse from 'parse'

import { requiredFields as companyRequiredFields } from './CompanyForm';
import { requiredFields as userRequiredFields } from './MemberForm';

import MemberInputs from './Inputs/MemberInputs'
import CompanyInputs from './Inputs/CompanyInputs';

@inject('adminStore')

@observer
class OnboardingForm extends Component {
    constructor(props) {
        super(props)

        const application = props.application
        console.log("DJASHGDHJASHDHD");
        console.log(application.region);

        this.state = {
            showAlert: false,

            companyImage: null,
            memberImage: null,

            imageUploading: false,
            imageUploaded: false,

            isLoading: false,
            loadingState: 0, // 0: Normal State, 1: Success, 2: Failure
            buttonText: 'SPEICHERN',

            partner: {
                name: application.company,
                uidNumber: application.uid,
                industry: application.industry,
                region: application.region,
            },

            user: {
                firstname: application.firstname,
                lastname: application.lastname,
                title: application.title,
                phone: application.phone,
                email: application.email,
                position: application.position,
                homeGolfCourse: application.golfcourse,
                handicap: application.handicap
            },

            contract: {
                fee: undefined,
                year: (new Date).getFullYear()+1
            },

            error: null,
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.updateStates = this.updateStates.bind(this)
    }

    // Reset button when form changes
    updateStates = () => {
        this.setState({
            isLoading: false,
            loadingState: 0, // 0: Normal State, 1: Success, 2: Failure
            buttonText: 'SPEICHERN',
        })
    }

    onSubmit = () => {
        this.setState({
            isLoading: true
        })

        const company = this.state.partner
        const user = this.state.user

        // Setting new image identifier if new image has been added
        company.logo = (this.state.companyImage !== null ? this.state.companyImage : company.logo)
        user.profileImage = (this.state.memberImage !== null ? this.state.memberImage : user.profileImage)

        Parse.Cloud.run("addCompanyWithUser", { company, user, createContact: true, contractFee: this.state.contract.fee, year: this.state.contract.year })
            .then(result => {
                // Setting states for proper button rendering
                this.setState({
                    isLoading: false,
                    loadingState: 1,
                    buttonText: 'GESPEICHERT'
                })
            })
            .catch(error => {
                // Setting states for proper button rendering
                this.setState({
                    isLoading: false,
                    loadingState: 2,
                    buttonText: 'ERNEUT',
                    error: error.message.message
                })
                console.error("error", error)
            })
    }

    render() {
        const isButtonDisabled = () => {
            // Use HTML validation for now
            return false

            const partner = this.state.partner;
            const contract = this.state.contract;

            if (!partner.objectId && (contract.fee == null || contract.fee === ""))
                return true

            for (let item of companyRequiredFields) {
                if (partner[item] === "" || partner[item] == null) {
                    return true
                }
            }

            const user = this.state.user;

            for (let item of userRequiredFields) {
                if (user[item] === "" || user[item] == null) {
                    return true
                }
            }

            // Check If Mail is Valid
            // partner["email"] should only be tested if not empty

            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (
                partner["email"] && (
                !re.test(String(partner["email"]).toLowerCase()) ||
                !re.test(String(partner["contactEmail"]).toLowerCase()) ||
                !re.test(String(user["email"]).toLowerCase())
                )
            )
                return true

            return false
        }

        console.log(this.state.partner);

        return (
            <div>
                <ContainerBox style={{maxWidth: 1200, margin: "20px auto"}}>
                    <Row style={{ paddingTop: 25, margin: 'auto' }}>
                        <Heading style={{ paddingLeft: 0, marginLeft: 37, fontWeight: 'bold' }}>
                            Bewerber akzeptieren
						            </Heading>

                        <div style={{ paddingLeft: 0, marginLeft: 37, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>

                        <Collapse in={this.state.showAlert}>
                            <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                                <h4>Kein gültiger Login</h4>
                                <p>Sie haben entweder ein falsches Passwort oder einen falschen Benutzernamen eingegeben!</p>
                            </Alert>
                        </Collapse>

                        <Form
                            className={'dashboard-form'}
                            onSubmit={this.onSubmit}
                            onChange={this.updateStates}
                            layout={'vertical'}
                            validatePristine={true}
                            disabled={this.state.loadingState === 3}
                        >

                            <Col md={12}>
                              <Heading style={{ paddingLeft: 0, marginLeft: 37 }}>
                                  1. Unternehmensdaten angeben
                              </Heading>
                            </Col>

                            <CompanyInputs onChange={(state) => { console.log(state); this.setState(state)}} data={this.state.partner} requiredFields={companyRequiredFields} contract={this.state.contract} />

                            <Col md={12}>
                              <Heading style={{ paddingLeft: 0, marginLeft: 37 }}>
                                  2. Mitgliedsdaten angeben
                              </Heading>
                            </Col>

                            <MemberInputs onChange={(state) => this.setState(state)} data={this.state.user} requiredFields={userRequiredFields} hide={["CompanySelect"]}/>

                            <Col md={12} className="text-center" style={{ paddingBottom: 45, display: 'flex', justifyContent: 'center' }}>
              								<p style={{
              									position: 'absolute',
              									display: 'block',
              									left: 0,
              									right: 0,
              									top: 14,
              									/* Conditional rendering of text according to loadingState */
              									transform: this.state.loadingState !== 0 ? (this.state.loadingState === 1 ? 'translateY(95px)' : 'translateY(50px)') : 'none',
              									color: this.state.loadingState === 2 ? 'rgb(217, 83, 79)' : '#DAB777',
              								}}>
              									{this.state.loadingState === 0 ? "" : (this.state.loadingState === 1 ? 'Erfolgreich angelegt' : this.state.error)}
              								</p>

              								{ this.state.loadingState !== 1 && <div>
              								<LodgeButtonLoadingRing style={{ transform: this.state.isLoading ? 'translateX(90px)' : 'none' }}></LodgeButtonLoadingRing>
              								<LogeButtonSlim
              									style={{
              										position: 'relative',
              										display: 'flex',
              										margin: 'auto !important',
              										alignItems: 'center',
              										justifyContent: 'center',
              										background: '#FFF',
              									}}
              									disabled={ isButtonDisabled() }
              									hoverFontColor={"white"}
              									// Conditional rendering of button according to loadingState
              									{...(this.state.loadingState === 2 ? { color: 'rgb(217, 83, 79)', fontColor: 'rgb(217, 83, 79)' } : {})}
              								>
              									{this.state.buttonText}
              								</LogeButtonSlim>
              								</div>}
              							</Col>
                        </Form>
                        {(this.state.loadingState === 1) &&
                          <div>
                            <Col md={12} className="text-center" style={{ paddingBottom: 45, display: 'flex', justifyContent: 'center' }}>
                                <LogeButtonSlim
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        margin: 'auto !important',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: '#FFF'
                                    }}
                                    hoverFontColor={"white"}
                                    onClick={() => this.props.history.push("/internal/admin/applications")}
                                >
                                    zurück zur Bewerbungsliste
								                </LogeButtonSlim>
                            </Col>
                            <Col md={12} className="text-center" style={{ paddingBottom: 45, display: 'flex', justifyContent: 'center' }}>
                                <LogeButtonSlim
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        margin: 'auto !important',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: '#FFF'
                                    }}
                                    hoverFontColor={"white"}
                                    onClick={() => this.props.history.push("/internal/admin/companies")}
                                >
                                    Firmenliste anzeigen
								                </LogeButtonSlim>
                                <LogeButtonSlim
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        margin: 'auto !important',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: '#FFF'
                                    }}
                                    hoverFontColor={"white"}
                                    onClick={() => this.props.history.push("/internal/admin/members")}
                                >
                                    Mitgliederliste anzeigen
								                </LogeButtonSlim>
                            </Col>
                          </div>
                        }
                    </Row>
                </ContainerBox>
            </div>
        );
    }
}

OnboardingForm.propTypes = {
    userStore: MobxPropTypes.observableObject,
    cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(OnboardingForm));



// WEBPACK FOOTER //
// /src/components/admin/Forms/OnboardingForm.js